import React from "react";

import styles from "./Salesforce.module.css";

export const aboutInstalled = (
	<>
		<div className={styles.header}>
			<span className={styles.headerTitle}>About this integration</span>
		</div>
		<div className={styles.settingsText}>
			<p>
				Fellow’s Salesforce integration streamlines the process of accessing your Salesforce information alongside your
				notes in Fellow. This enables you to prepare before your calls and effortlessly send your notes to Salesforce,
				ensuring all your customer information remains consolidated in one place.
			</p>
			<ul>
				<li className={styles.listItem}>
					Fellow will search the emails of external attendees on a calendar event for contacts or leads in Salesforce.
					Then, it will show information from Salesforce about those contacts and leads alongside your meeting notes in
					Fellow.
				</li>
				<li className={styles.listItem}>
					Fellow notes sent as a Note to Salesforce can be found under the “Notes” or “Notes & Attachments” label of an
					object’s related list section.
				</li>
				<li className={styles.listItem}>
					Fellow notes sent as a Call (Task) to Salesforce can be found under the object’s activity feed.
				</li>
				<li className={styles.listItem}>
					Fellow meeting notes that are automatically sent will be logged under the contact, lead or opportunity related
					to the external attendees on the calendar event
				</li>
			</ul>
		</div>
	</>
);
